import styled from 'styled-components';
import mediaQueries from 'syf-component-library/const/mediaQueries';
import { colors, spacing } from '../../../styles/theme';
import { StyledFlex } from '../../../styles/common';
export const StyledModalHeader = styled(StyledFlex) `
  background-color: ${colors.lightestGrey};
  border-bottom: 1px solid rgba(34, 36, 38, 0.15);
  margin: 0;
  max-height: 56px;
  padding: ${spacing.base}px ${spacing.large}px;
`;
export const StyledModalActions = styled(StyledFlex) `
  width: 100%;
  padding: ${spacing.large}px ${spacing.base}px;
  background-color: ${colors.lightestGrey};
  border-top: 1px solid ${colors.lightGrey};

  button + button {
    margin-bottom: ${spacing.base}px;
  }

  @media ${mediaQueries.greaterThanMedium} {
    flex-direction: row;
    padding: ${spacing.large}px;

    button + button {
      margin-bottom: 0;
      margin-left: ${spacing.large}px;
    }
  }

  @media ${mediaQueries.lessThanMedium} {
    .safari-toolbar-hidden {
      padding-bottom: 4rem;
    }
  }
`;
//# sourceMappingURL=subcomponents.js.map